<template>
    <div class="field checkbox" :class="[ { 'no-placeholder': !label, 'checked': value === '1' || value === true } ]">
        <div class="input-group">
            <label class="input">
                <input
                    type="checkbox"
                    :name="name"
                    value="1"
                    :disabled="disabled"
                    @change="handleChange"
                    @focus="handleFocus"
                    @blur="handleBlur"
                    ref="checkbox"
                />
                <span>{{ label }}</span>
            </label>
            <span class="icons"></span>
        </div>
        <strong class="tip" v-if="tip">{{ tip }}</strong>
    </div>
</template>

<script>
export default {
    name: "checkBoxField",
    props: {
        name: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
        value: {
            type: String,
            default: ""
        },
        tip: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    emits: [
        "value-updated",
        "event:blur",
        "event:focus",
        "event:change"
    ],
    data() {
        return {
            alreadyLoaded: false,
        };
    },
    updated() {
        if (this.alreadyLoaded) return;
        const checkbox = this.$el.querySelector(`input[name="${this.name}"]`);
        if (checkbox) {
            checkbox.checked = this.value === "1" || this.value === true;
        }
        this.alreadyLoaded = true;
    },
    watch: {
        value(newValue) {
            const checkbox = this.$refs.checkbox;
            if (checkbox) {
                if (!checkbox.checked && (newValue === "1" || newValue === true)) {
                    checkbox.checked = true;
                } else if (checkbox.checked && (newValue !== "1" && newValue !== true)) {
                    checkbox.checked = false;
                }
            }
        },
    },
    methods: {
        handleChange(event) {
            const isChecked = event.target.checked;
            const value = isChecked ? event.target.value : "";
            this.$emit("event:change", value);
            this.$emit("value-updated", { key: this.name, value, type: 'checkbox' });
        },
        handleBlur() {
            this.$emit('event:blur');
        },
        handleFocus() {
            this.$emit('event:focus');
        }
    },
};
</script>
